import { render, staticRenderFns } from "./UpDateCarInfoDialog.vue?vue&type=template&id=2a84e2bc&scoped=true"
import script from "./UpDateCarInfoDialog.vue?vue&type=script&lang=js"
export * from "./UpDateCarInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84e2bc",
  null
  
)

export default component.exports